var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeOfContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1196 1H1.3806C1.17042 1 1 1.17015 1 1.38V19.62C1 19.7208 1.0401 19.8175 1.11146 19.8887C1.18282 19.96 1.27967 20 1.3806 20H16.1196C16.2205 20 16.3173 19.96 16.3887 19.8887C16.4601 19.8175 16.5002 19.7208 16.5002 19.62V1.38C16.5002 1.27923 16.4601 1.18253 16.3887 1.11129C16.3173 1.04004 16.2205 1 16.1196 1ZM15.739 19.24H1.76119V1.76H15.739V19.24Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4932 4.97015H13.0069C13.2134 4.97015 13.3807 4.77968 13.3807 4.54477C13.3807 4.30987 13.2134 4.1194 13.0069 4.1194H4.4932C4.28677 4.1194 4.11938 4.30987 4.11938 4.54477C4.11938 4.77968 4.28677 4.97015 4.4932 4.97015Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4932 7.80596H13.0069C13.2134 7.80596 13.3807 7.61549 13.3807 7.38059C13.3807 7.14569 13.2134 6.95522 13.0069 6.95522H4.4932C4.28677 6.95522 4.11938 7.14569 4.11938 7.38059C4.11938 7.61549 4.28677 7.80596 4.4932 7.80596Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4932 10.6418H13.0069C13.2134 10.6418 13.3807 10.4513 13.3807 10.2164C13.3807 9.9815 13.2134 9.79103 13.0069 9.79103H4.4932C4.28677 9.79103 4.11938 9.9815 4.11938 10.2164C4.11938 10.4513 4.28677 10.6418 4.4932 10.6418Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39066 16.3134H13.007C13.2134 16.3134 13.3808 16.123 13.3808 15.8881C13.3808 15.6531 13.2134 15.4627 13.007 15.4627H8.39066C8.18423 15.4627 8.01685 15.6531 8.01685 15.8881C8.01685 16.123 8.18423 16.3134 8.39066 16.3134Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeOfContact);
export default __webpack_public_path__ + "static/media/type-of-contact.3a6971ff62ded301e40aa3f9a23621fe.svg";
export { ForwardRef as ReactComponent };